
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CatalogFeature } from '@/config/onboardPricingCatalog';
import {
  planBadgeLabel,
  upgradeCtaLabel,
  upgradeFeatures,
  upgradeHeadline,
  upgradeIntroLine,
  upgradeTagline,
} from './upgradeModalCopy';

@Component
export default class UpgradeModal extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: '' }) featureName!: string;
  @Prop({ default: 'Professional' }) requiredPackage!: string;
  @Prop({ default: '' }) description!: string;
  @Prop({ default: () => [] }) benefits!: string[];

  get dialog(): boolean {
    return this.value;
  }

  set dialog(val: boolean) {
    this.$emit('input', val);
  }

  get planBadgeLabel(): string {
    return planBadgeLabel(this.requiredPackage);
  }

  get headline(): string {
    return upgradeHeadline(this.featureName, this.requiredPackage);
  }

  get tagline(): string {
    return upgradeTagline(this.description, this.requiredPackage);
  }

  get features(): CatalogFeature[] {
    return upgradeFeatures(this.benefits, this.requiredPackage);
  }

  get introLine(): string {
    return upgradeIntroLine(this.benefits, this.requiredPackage);
  }

  get ctaLabel(): string {
    return upgradeCtaLabel(this.requiredPackage);
  }

  close(): void {
    this.dialog = false;
  }

  learnMore(): void {
    this.$emit('learn-more', this.requiredPackage);
    this.close();
  }
}
